import React, { useContext } from 'react';
import ChannelContext from '../ChannelContext';
import { StructuredData } from './StructuredData';
function StructuredBreadcrumbData({ parents, breadcrumbText }) {
    const { selectedChannel } = useContext(ChannelContext);
    let mappedParents = [];
    if (parents && parents.length > 0) {
        mappedParents = parents.map((parent, index) => {
            var _a;
            return {
                '@type': 'ListItem',
                position: parents.length - index,
                name: (_a = parent.object) === null || _a === void 0 ? void 0 : _a.breadcrumbText.toString(),
                item: `${selectedChannel.url}${parent.path}`
            };
        });
        mappedParents.reverse();
        const data = {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
                ...mappedParents,
                {
                    '@type': 'ListItem',
                    position: parents.length + 1,
                    name: breadcrumbText.toString()
                }
            ]
        };
        return React.createElement(StructuredData, { json: data });
    }
    else
        return null;
}
export { StructuredBreadcrumbData };
//# sourceMappingURL=StructuredBreadcrumbData.js.map